/* eslint-disable no-useless-escape */
import React, { useContext, FC } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '@material-ui/core'
import { SendOutlined } from '@material-ui/icons'
import SignupLayout from '../../layout'
import LeftImageSection from '../../layout/leftImageSection'
import { SignupContext } from '../../context/SignupContextContainer'
import SIGNUP_STEPS from '../../utils/constants'

const Recon: FC = () => {
  const { setSignupStep } = useContext(SignupContext)
  const history = useHistory()

  const title = (): JSX.Element => {
    return (
      <div className="left-title">
        <p>EASILY FIND,</p>
        <p>QUALIFIED </p>
        <p>PROSPECTS </p>
      </div>
    )
  }

  const skipStep = (): void => {
    setSignupStep(SIGNUP_STEPS.CUSTOMERS)
    history.push('/client/customers')
  }

  const toCriteria = (): void => {
    setSignupStep(SIGNUP_STEPS.CRITERIA)
    history.push('/client/criteria')
  }

  return (
    <SignupLayout page="recon">
      <LeftImageSection title={title()} img="/assets/images/8.jpg" />
      <div className="signup-form">
        <p className="sub-title no-border">FIND THE RIGHT PEOPLE TO CONECT WITH</p>
        <p className="description">
          Recon Assist guides you through identifying the right people for you to send perfectly
          crafted emails to at the right time.
        </p>
        <div className="form">
          <div className="button-container">
            <Button
              size="large"
              variant="contained"
              color="primary"
              style={{ marginRight: 10 }}
              onClick={toCriteria}
            >
              <SendOutlined style={{ marginRight: 10 }} />
              LAUNCH RECON ASSIST
            </Button>
            {/* <Button size="large" variant="contained" color="primary">
              DIY RECON SET UP
            </Button> */}
          </div>
          <Button size="medium" color="primary" className="skipThis" onClick={skipStep}>
            Skip this step.
          </Button>
        </div>
      </div>
    </SignupLayout>
  )
}
export default Recon
